<template>
  <v-toolbar flat tile color="transparent" dark>
    <!-- Back Arrow with Badges -->
    <template v-if="view == 'detail'">
      <v-btn icon exact v-if="route_contains(['edit', 'delete'])" :to="{ name: `${mode}Show`, params: { uuid: $route.params.uuid } }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn icon exact v-else-if="is_route('resultShow')" @click="$router.go(-1)"><v-icon>mdi-arrow-left</v-icon></v-btn>
      <v-btn icon exact v-else :to="{ name: `${mode}List` }"><v-icon>mdi-arrow-left</v-icon></v-btn>
    </template>
    <template v-else>
      <v-btn icon exact v-if="!is_route('home')" :to="{ name: `home` }"><v-icon>mdi-arrow-left</v-icon></v-btn>
    </template>
    <v-btn fab icon v-if="is_route('home')" :to="{ name: `${mode}List` }">
      <v-icon>{{ icon }}</v-icon>
    </v-btn>
    <!-- Toolbar title -->
    <v-toolbar-title class="mr-5 overflow-visible">
      <template v-if="['list'].includes(view)">
        {{ titleText }}
      </template>
      <template v-else>
        <template v-if="!(['application','agent'].includes(mode))">
          <rename :text="titleText" :uuid="$route.params.uuid" :mode="mode" v-on:rename="onRename" :key="$route.params.uuid" />
        </template>
        <template v-else>{{ titleText }}</template>
      </template>
    </v-toolbar-title>
    <!-- Create button -->
    <template v-if="!route_contains(['create']) && !['application','agent'].includes(mode)">
      <ax-button icon="mdi-plus" tooltip="New" @clicked="$router.push({ name: `${mode}Create` })" />
    </template>
    <!-- Update buttons -->
    <template v-if="view == 'detail'">
      <template v-if="!['application', 'agent'].includes(mode)">
        <template v-if="!route_contains(['create'])">
          <ax-button v-if="isOwner(item)" icon="mdi-pencil-outline" tooltip="Edit" :disabled="isValidStatus" @clicked="$router.push({ name: `${mode}Edit`, params: { uuid: $route.params.uuid } })" />
          <ax-button v-if="isOwner(item)" icon="mdi-content-copy" tooltip="Copy" :disabled="isValidStatus" @clicked="$emit('clone')" />
          <ax-button v-if="isOwner(item)" icon="mdi-trash-can-outline" tooltip="Delete" :disabled="isValidStatus" confirm danger @confirmed="$emit('delete')" />
          <share v-if="isOwner(item)" :mode="mode" :item="item" />
          <transfer v-if="isOwner(item)" :mode="mode" :item="item" @transfer="onTransfer" />
        </template>
      </template>
    </template>
    <slot></slot>
  </v-toolbar>
</template>
<script>
import AxButton from "@/components/button"
import Rename from "@/components/rename"
import Transfer from "@/components/transfer"
import Share from "@/components/share"
export default {
  name: "Toolbar",
  components: {
    AxButton,
    Rename,
    Transfer,
    Share
  },
  props: {
    view: { type: String, default: "detail" },
    mode: { type: String, required: true },
    title: { type: String, default: "TITLE" },
    item: { type: Object, default: null },
    icon: { type: String, default: null },
    small: { type: Boolean, default: false },
  },
  watch: {
    search: function(val, old) {
      this.$emit("searched", val)
    },
    "sort.by": function(val, old) {
      this.$emit("sortBy", val)
    },
    "sort.desc": function(val, old) {
      this.$emit("sortDesc", val)
    }
  },
  computed: {
    titleText() {
      if (this.title !== "TITLE") return this.title
      if (this.item) {
        if (this.item.name) return this.item.name
        return this.item.uuid
      }
      return this.capitalize(this.pluralize(this.mode))
    },
    isValidStatus() {
      if (this.item) return ["PENDING", "STARTED"].includes(this.item.status)
      return false
    }
  },
  methods: {
    onRename(value) {
      this.item.name = value
    },
    onTransfer(transferred, message) {
      if (transferred) {
        this.notify(message)
      }
    }
  }
}
</script>